import {initTooltipComponent} from './editor';
import loadRTE from './rte';

/**
 * Tooltip component entry point.
 */
export default (editor, opts = {}) => {
  const defaultOptions = {
    componentType: 'tooltip',
    category: 'Basic'
  };

  const options = {
    ...defaultOptions,
    ...opts
  };

  initTooltipComponent(editor, options);
  loadRTE(editor, options);
};
